<script setup lang="ts">
type VolumeOption = number | string

const props = defineProps<{
  volumes: VolumeOption[]
  id?: string
}>()

const model = defineModel<VolumeOption | null>({ default: null })

const internalValue = computed<VolumeOption | undefined>({
  get: () => (model.value == null ? undefined : model.value),
  set: (val) => {
    model.value = typeof val === 'number' || typeof val === 'string' ? val : null
  },
})
</script>

<template>
  <div class="w-64">
    <FormComboboxWithBadge
      :id="props.id || 'journal-volume'"
      v-model="internalValue"
      :options="props.volumes"
      clearable
      :option-label="(v: VolumeOption) => String(v)"
      :multiple="false"
      :badge="false"
      :searchable="false"
      label="Filtrer på volum"
      placeholder="Volum"
    />
  </div>
</template>
